import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ToastService } from "./toast.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class ClientService {
  private base_url = `${environment.API_URL}/client`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  //PLANNINGS
  getPlanning(params) {
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getMonthlyStats(params) {
    params = { month_date: params };
    return this.http
      .post(this.base_url + "/stats", params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  countAll(params) {
    
    return this.http
      .post(this.base_url+'/total', params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  createPlanning(params) {
    return this.http
      .post(this.base_url + "/create", params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        this.toast.success(
          "Transport Ajouté au Planning avec succès.",
          false,
          "Planning"
        );
        return response;
        //window.location.reload();
      });
  }
  updatePlanning(planning_id: number, params: object) {
    return this.http
      .patch(`${this.base_url}/${planning_id}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Transport Mise à jour.", false, "Planning");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour du Transport.",
            false,
            "Planning"
          );
        }
      });
  }

  getPlanningById(planning_id) {
    return this.http
      .get(this.base_url + '/planning/' + parseInt(planning_id), { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  sendNewPlanningMail(planning_id) {
    var params = {};
    params["planning_id"] = planning_id;
    return this.http
      .post(`${this.base_url}/new/${planning_id}/sendmail`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response == 200) {
          this.toast.success(
            "Demande envoyée.",
            false,
            "Mail"
          );
        }
      });
  }

  // TASKS
  getTasks(planning_id: number = null) {
    var params = {};
    if (planning_id) {
      params["id"] = planning_id;
      return this.http
        .post(this.base_url + "/" + params["id"]+"/tasks", params, {
          headers: this.headers,
        })
        .map((res) => JSON.parse(JSON.stringify(res)));
    } else {
      //console.log('pas de planning');
      return this.http
        .get(this.base_url + "/tasks", { headers: this.headers })
        .map((res) => JSON.parse(JSON.stringify(res)));
    }
  }

  createTask(params: object) {
    //params['id'] => planning id
    return this.http
      .post(this.base_url + "/" + params["id"]+"/task", params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
        } else {
          //console.log(response);
          this.toast.error(
            "Erreur lors de l'ajout de la Tâche.",
            false,
            "Tâche"
          );
        }
      });
  }

  updateTask(params: object) {
    //params["token"] = this.token;
    return this.http
      .patch(this.base_url + "/task/"+params["id"], params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Tâche Mise à jour.", false, "Tâche");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de la Tâche",
            false,
            "Tâche"
          );
        }
      });
  }

  deleteTask(task_id) {
    return this.http
      .delete(`${this.base_url}/task/${task_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Tâche Supprimée.", false, "Tâche");
        } else {
          this.toast.error(
            "Erreur lors de la suppression de la Tâche.",
            false,
            "Tâche"
          );
        }
      });
  }

  /** INCIDENTS **/
  getIncidents(planning_id: number) {
    var params = {};
    params["id"] = planning_id;
    return this.http
      .post(this.base_url + "/"+params["id"] + "/incidents", params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createIncident(params: object) {
    return this.http
      .post(this.base_url + "/"+params["id"] + "/incident", params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
        } else {
          this.toast.error(
            "Erreur lors de l'ajout de l'incident.",
            false,
            "Incident"
          );
        }
      });
  }

  updateIncident(params: object) {
    return this.http
      .patch(this.base_url + "/incident/"+params["id"], params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Incident Mise à jour.", false, "Incident");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de l'incident",
            false,
            "Incident"
          );
        }
      });
  }

  deleteIncident(incident_id) {
    return this.http
      .delete(`${this.base_url}/incident/${incident_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Incident Supprimé.", false, "Incident");
        } else {
          this.toast.error(
            "Erreur lors de la suppression de l'incident.",
            false,
            "Incident"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/client.service.ts